import { Order } from "@greeter/core";
import { DateFactory } from "@greeter/date";
import { mockProduct } from "./MockProduct";

export const mockOrder: Order = {
  id: "asdf",
  createdAt: DateFactory.create(),
  orderLines: [
    {
      quantity: 1,
      product: { ...mockProduct },
      id: "asdf",
      description: "asdf",
      title: "asdf",
      unitPrice: 100,
      children: [],
    },
  ],
  status: "pending",
  total: 100,
  venueId: "",
  customerId: "",
};
